import log from "../utils/log";

export class BikehubServicesDisplay {
  init() {
    $("#bikehubServicesPaneNav a").on("click", function(e) {
      e.preventDefault();
      $(this).tab("show");
      bikehubLocations.rerenderMarkers();
    });
  }
}
